import { gql } from "@apollo/client";

export const METRICS_EXPLORER_REPORT = gql`
  query GetMetricsExplorerReport(
    $accountingMode: String!
    $attributionModel: String!
    $attributionWindow: String!
    $level: String!
    $timeGranularity: String!
    $dateRange: SalesDateRangeInput!
    $dimensionIds: [String!]!
    $metricIds: [String!]!
    $advancedSearch: JSONObject
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $sorting: [SalesSortingInput!]
  ) {
    me {
      metricsExplorerReport(
        accountingMode: $accountingMode
        attributionModel: $attributionModel
        attributionWindow: $attributionWindow
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        dimensionIds: $dimensionIds
        metricIds: $metricIds
        advancedSearch: $advancedSearch
        breakdownFilters: $breakdownFilters
        sorting: $sorting
      ) {
        rows
        summary
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;
